import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { createOrg, modifyOrg, delOrg } from '../../../api/user';
import { EventBus } from '@blade/common';
let default_1 = class default_1 extends Vue {
    visible;
    showRemove;
    selectedNode;
    form = {
        name: '',
    };
    rules = {
        name: [
            { required: true, message: this.$t('common.pleaseInput'), trigger: ['blur', 'submit'] },
            { min: 1, max: 50, message: this.$t('maxLenth'), trigger: 'blur' },
        ],
    };
    handleClose() {
        this.$emit('update:visible', false);
        this.form.name = '';
    }
    mounted() {
        EventBus.$on('getOrgName', (data) => {
            this.form.name = data;
        });
    }
    async onSubmit() {
        try {
            await this.$refs.formRef?.validate();
            const { name } = this.form;
            const data = {
                name: name,
            };
            if (this.showRemove) {
                data.id = this.selectedNode?.data?.org.id;
                await modifyOrg(data);
            }
            else {
                data.pid = this.selectedNode?.data?.org.id;
                await createOrg(data);
            }
            EventBus.$emit('getUserList');
            this.$elmessage.success(this.$t('common.operationSuccess').toString());
            this.handleClose();
            this.$parent.getOrgTree();
            EventBus.$emit('getuserDetail');
        }
        catch (e) { }
    }
    onRemove() {
        if (this.selectedNode.level === 1) {
            this.$message({
                message: this.$t('cannotBeDeleted'),
                type: 'warning',
                customClass: 'zZindex',
            });
            return;
        }
        try {
            delOrg(this.selectedNode?.data?.org.id).then(() => {
                this.$elmessage.success(this.$t('common.operationSuccess').toString());
                this.$parent.getOrgTree();
                EventBus.$emit('getUserList');
                this.handleClose();
            });
        }
        catch (e) { }
    }
};
__decorate([
    Prop()
], default_1.prototype, "visible", void 0);
__decorate([
    Prop()
], default_1.prototype, "showRemove", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectedNode", void 0);
default_1 = __decorate([
    Component({
        name: 'add-modal',
        i18n: {
            messages: {
                en: {
                    title: 'Create Area',
                    editTitle: 'Edit Area',
                    name: 'Departments name',
                    parent: 'Parent node',
                    status: 'Area status',
                    removeConfirm: 'Are you sure delete this area?',
                    maxLenth: 'Maximum 50 characters',
                    cancel: 'Cancel',
                    submit: 'Submit',
                    cannotBeDeleted: 'Primary departments cannot be deleted',
                },
                zh: {
                    title: '创建部门',
                    editTitle: '编辑部门',
                    name: '部门名称',
                    parent: '父节点',
                    status: '区域状态',
                    removeConfirm: '确定要删除这个部门吗？',
                    maxLenth: '最多50个字符',
                    cancel: '取消',
                    submit: '确认',
                    cannotBeDeleted: '一级部门不可删除',
                },
            },
        },
    })
], default_1);
export default default_1;
